import { AppointmentsAvailableTimesServant } from '../servants/appointments_available_times_servant';

export interface IAppointmentsTabsConfiguration {
  read(): IAppointmentsTabsConfigurationDataType;
  stepCompleted(state: string): void;
  resetNextSteps(state: string): void;
  stepInComplete(state: string): void;
  disableStep(state: string): void;
  resetToDefault(): void;
  states(): IAppointmentsStates;
}

export interface IAppointmentsTabsConfigurationProvider {
  configure(): void;
}

export interface IAppointmentsTabsConfigurationOptions {
  state: string;
  name: string;
  isActiveOnLoad: boolean;
  isCompleted: boolean;
  isDisabled: boolean;
  title: string;
  icon: string;
  previousState: string;
  nextState: string;
  isActive: boolean;
}

export type IAppointmentsTabsConfigurationDataType = Record<string, IAppointmentsTabsConfigurationOptions>;

export interface IAppointmentsStates {
  reason: string;
  location: string;
  availableTimes: string;
  walkIn: string;
  alternateTimes: string;
  alternateTimesConfirm: string;
  confirm: string;
  scheduled: string;
}

export class AppointmentsTabsConfiguration implements ng.IServiceProvider, IAppointmentsTabsConfigurationProvider {
  private _baseAppointmentState: string = 'my.appointments';

  private _reasonState = `${this._baseAppointmentState}.appointment_reason`;
  private _locationStaffState = `${this._baseAppointmentState}.location_staff`;
  private _availableTimesState = `${this._baseAppointmentState}.available_times`;
  private _walkInTimesState = `${this._baseAppointmentState}.walkin_times`;
  private _alternateTimesState = `${this._baseAppointmentState}.alternate_appointment_times`;
  private _alternateTimesConfirm = `${this._baseAppointmentState}.alternate_appointment_times_confirm`;
  private _confirm = `${this._baseAppointmentState}.confirm`;
  private _scheduled = `${this._baseAppointmentState}.scheduled`;

  private static TABS: IAppointmentsTabsConfigurationDataType;

  configure(): void {
    AppointmentsTabsConfiguration.TABS = {
      1: {
        state: this._reasonState,
        name: 'Reason',
        isActiveOnLoad: true,
        isDisabled: false,
        isCompleted: false,
        title: 'Reason',
        icon: 'bubble_question',
        previousState: '',
        nextState: this._locationStaffState,
        isActive: false
      },
      2: {
        state: this._locationStaffState,
        name: 'Location & Staff',
        isActiveOnLoad: false,
        isDisabled: false,
        isCompleted: false,
        title: 'Location and Staff',
        icon: 'user',
        previousState: this._reasonState,
        nextState: this._availableTimesState,
        isActive: false
      },
      3: {
        state: this._availableTimesState,
        name: 'Available Times',
        isActiveOnLoad: false,
        isDisabled: false,
        isCompleted: false,
        title: 'Select available times',
        icon: 'calender',
        previousState: this._locationStaffState,
        nextState: this._confirm,
        isActive: false
      },
      4: {
        state: this._confirm,
        name: 'Confirm',
        isActiveOnLoad: false,
        isDisabled: false,
        isCompleted: false,
        title: 'Confirm appointment',
        icon: 'check',
        previousState: this._availableTimesState,
        nextState: '',
        isActive: false
      }
    };
  }

  resetToDefault(): void {
    this.configure();
  }

  $get(ngAppointmentsAvailableTimesServant: AppointmentsAvailableTimesServant): IAppointmentsTabsConfiguration {
    return {
      read: (): IAppointmentsTabsConfigurationDataType => {
        return AppointmentsTabsConfiguration.TABS;
      },
      stepCompleted: (step: string): void => {
        AppointmentsTabsConfiguration.TABS[step].isCompleted = true;
      },
      resetNextSteps: (step: string): void => {
        ngAppointmentsAvailableTimesServant.clearWeekOffSet();
        let nextState: string = AppointmentsTabsConfiguration.TABS[step].nextState;
        while (nextState !== '') {
          const nextStep = _.find(AppointmentsTabsConfiguration.TABS, {
            state: nextState
          });
          if (!!nextStep) {
            nextStep.isCompleted = false;
            nextState = nextStep.nextState;
          }
        }
      },
      stepInComplete: (step: string): void => {
        AppointmentsTabsConfiguration.TABS[step].isCompleted = false;
      },
      disableStep: (step: string): void => {
        AppointmentsTabsConfiguration.TABS[step].isDisabled = true;
      },
      resetToDefault: (): void => this.configure(),
      states: (): IAppointmentsStates => {
        return {
          reason: this._reasonState,
          location: this._locationStaffState,
          availableTimes: this._availableTimesState,
          walkIn: this._walkInTimesState,
          alternateTimes: this._alternateTimesState,
          alternateTimesConfirm: this._alternateTimesConfirm,
          confirm: this._confirm,
          scheduled: this._scheduled
        };
      }
    };
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/servants/appointments_tabs_configuration.ts